module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Medium.17ad92a2.ttf";